// extracted by mini-css-extract-plugin
export default {"lowSupplyCard":"lowSupplyCard__NWFhO","dek":"dek__N2ExM"};